import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';

const selectKamereoFreshDomain = (state: ApplicationRootState) => state.kamereoFreshPage || initialState;

const selectKamereoFreshPage = () => createSelector(selectKamereoFreshDomain, (substate) => substate);

const selectLoading = () => createSelector(selectKamereoFreshDomain, (substate) => substate.loading);
const selectSections = () => createSelector(selectKamereoFreshDomain, (substate) => substate.sections);
const selectNoteItemLoading = () => createSelector(selectKamereoFreshDomain, (substate) => substate.loadingNote);

export default selectKamereoFreshPage;
export { selectKamereoFreshDomain, selectLoading, selectSections, selectNoteItemLoading };
